
<template>
  <div class="aboutUsCont">
    <div class="banner-cont"></div>
    <div class="main-cont flex-lay-row wrap part0">
      <title-content :msgObj="titleObj0"></title-content>
      <div class="img"></div>
    </div>
    <div class="main-cont part1">
      <ul class="flex-lay-row wrap">
        <li v-for="(item, ind) in list0" :key="ind" :class="`item_${ind}`"> 
          <i></i>
          <title-content :msgObj="item.titleObj"></title-content>
          <p>{{item.txt}}</p>
        </li>
      </ul>
    </div>
    <div class="main-cont flex-lay-row wrap part2">
      <div class="img img0"></div>
      <div class="img img1 flex-lay-column">
        <p>DAWNING TECHNOLOGY CO., LIMITED </p>
        <span>邮箱：support@dwngtechs.com</span>
        <span>地址：RM A1, 11/F WINNER BLDG, 36 MAN YUE ST, HUNG HOM, KOWLOON</span>
      </div>
    </div>
  </div>
</template>
<script>
export default{
  name: 'aboutUsCont',
  data () {
    return {
      currentIndex: 0,
      titleObj0: {
        horizontal: 'left',
        title1: '致力于通过技术研发',
        title2: 'DAWNING TECHNOLOGY是致力于通过技术研发、业务实训、平台运营三大版块打造电子商务生态系统的互联网公司。基础业务有建站业务、全景业务、营销业务为客户提供一站式智慧营销解决方案，制定互联网服务标准。<br><br>公司秉承着“为用户提供服务！”的经营理念，已为众多企业搭建好有效的互联网平台。在业界取得骄人成绩。公司遵循“感恩、喜乐、健康、致知、诚意、正心”的价值观，以及“敢想敢为，说到做到；坚持到底，永不放弃”的精神。致力实现员工、客户、社会等多方满意多方和谐的环境。'
      },
      list0: [
        {titleObj: {title1: '全网络推广'}, txt: 'AI•智能推广以云计算为支持，7大搜索引擎全覆盖。并通过多平台多渠道的全面网络推广方式，覆盖电脑端和手机端，不仅解决被搜到，而且提升可信度。全网推广直通2000多家平台全面覆盖优势霸屏'},
        {titleObj: {title1: '方案集成'}, txt: '技术研发、业务实训、平台运营；以产、学、研的模式提供一站式的互联网服务。并通过多年的积累，在业内整合了丰富的资源，打通了多方渠道。可以根据客户的需求定制出较优解决方案'}
      ]
    }
  },
  methods: {
    changePage (i) {
      this.currentIndex = i
    }
  }
}
</script>
<style lang="scss" scoped>
.aboutUsCont{
  .banner-cont{
    background-image: url('../../assets/dawing/ia_400000008.jpg');
  }
  .part1{
    ul{
      justify-content: space-between;
      li{
        width: 5.4rem;
        margin-bottom: .3rem;
        .subtitle{
          display: none;
        }
        i{
          height: 3.6rem;
          display: block;
        }
        p{
          width: 90%;
          margin: 0 auto;
          text-align: center;
          line-height: .3rem;
          color: #777;
        }
      }
    }
  }
  .part0{
    padding-top: 1.3rem;
    .img{
      width: 5.9rem;
      flex-shrink: 0;
      height: 3.5rem;
      background: url('../../assets/dawing/ia_400000000.png') no-repeat right;
      background-size: contain;
    }
  }
  .part2{
    .img{
      height: 4rem;
      width: 5rem;
    }
    .img1{
      color: #fff;
      align-items: flex-start;
      padding-left: .4rem;
      p{
        margin-bottom: .3rem;
        font-size: .3rem;
      }
      span{
        line-height: .3rem;
      }
    }
  }
}
@for $i from 0 to 2{
  .part1 .item_#{$i} i{
    background: url('../../assets/dawing/ia_40000000#{$i + 1}.png') no-repeat center;
    background-size: contain;
  }
  .part2 .img#{$i} {
    background: url('../../assets/dawing/about_item_#{$i}.png') no-repeat center;
    background-size: cover;
  }
  .part#{$i} {
    padding: 1.3rem 0;
  }
}
.part2 {
  padding: 1.3rem 0;
}
@media (max-width: 980px) {
  .aboutUsCont .part1 ul{
    justify-content: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DAWNING/aboutUs.vue